export default function HeroSection() {
  const handleScroll = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative min-h-[600px] lg:min-h-[680px] flex items-center overflow-hidden bg-background-950"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20dark%20dramatic%20background%20with%20warm%20red%20and%20amber%20glowing%20particles%20floating%20upward%20like%20trending%20signals%20deep%20black%20base%20with%20pulsing%20energy%20waves%20cinematic%20atmosphere%20mysterious%20vibe&width=1440&height=700&seq=hero-bg-main&orientation=landscape"
          alt="网红爆料平台主视觉背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-background-950/90 via-background-950/70 to-background-950/50"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-16 lg:py-20">
        <div className="max-w-[1440px] mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-accent-500/15 border border-accent-500/30 mb-5">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-fire-fill text-accent-500 text-xs"></i>
              </div>
              <span className="text-xs font-medium text-accent-500 whitespace-nowrap">全网最新网红内幕 · 实时追踪</span>
            </div>

            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-background-50 font-heading leading-tight">
              网红爆料
              <span className="block text-accent-500 mt-2">全网最全网红黑料实锤解说平台</span>
            </h1>

            <p className="text-sm lg:text-base text-accent-500/80 mt-4 font-heading tracking-wide">
              每日更新 · 热门合集 · 吃瓜视频一网打尽
            </p>

            <div className="mt-6 space-y-3 lg:space-y-4">
              <p className="text-sm md:text-base text-background-200 leading-relaxed max-w-xl mx-auto lg:mx-0">
                网红爆料致力于聚合全网最新、最全的网红内幕实锤视频与深度解说。
                从直播带货翻车到MCN黑幕揭秘，从人设崩塌实录到短视频造假实锤，
                我们以专业视角还原事件真相，打造最有温度的吃瓜社区。
              </p>
              <p className="text-sm md:text-base text-background-200 leading-relaxed max-w-xl mx-auto lg:mx-0">
                当前全网最热话题聚焦直播翻车与网红塌房事件，
                多起千万粉级别网红相继被曝内幕，吃瓜热度持续飙升。
              </p>
            </div>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mt-7">
              <div className="text-center">
                <div className="text-xl md:text-2xl font-bold text-background-50 font-heading">3,628+</div>
                <div className="text-xs text-background-400 mt-1">原创爆料视频</div>
              </div>
              <div className="w-px h-10 bg-background-600"></div>
              <div className="text-center">
                <div className="text-xl md:text-2xl font-bold text-accent-500 font-heading">每日更新</div>
                <div className="text-xs text-background-400 mt-1">7×24小时不间断</div>
              </div>
              <div className="w-px h-10 bg-background-600 hidden sm:block"></div>
              <div className="text-center hidden sm:block">
                <div className="text-xl md:text-2xl font-bold text-background-50 font-heading">多方验证</div>
                <div className="text-xs text-background-400 mt-1">杜绝虚假信息</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3 mt-8">
              <a
                href="#media"
                onClick={(e) => handleScroll(e, '#media')}
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-lg text-sm transition-colors whitespace-nowrap cursor-pointer"
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-play-circle-line text-base"></i>
                </div>
                立即观看热门视频
              </a>
              <a
                href="#contact"
                onClick={(e) => handleScroll(e, '#contact')}
                className="inline-flex items-center gap-2 px-6 py-3 bg-background-50/10 hover:bg-background-50/20 text-background-50 border border-background-400/30 font-medium rounded-lg text-sm transition-colors whitespace-nowrap cursor-pointer"
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-mail-send-line text-base"></i>
                </div>
                投稿爆料线索
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none">
            <div className="relative rounded-2xl overflow-hidden aspect-[4/3] bg-background-800">
              <img
                src="https://readdy.ai/api/search-image?query=stylized%20dark%20breaking%20news%20concept%20with%20glowing%20red%20headlines%20floating%20social%20media%20icons%20and%20magnifying%20glass%20symbolizing%20investigation%20warm%20dramatic%20lighting%20cinematic%20atmosphere%20trending%20topic%20visualization&width=700&height=525&seq=hero-visual-main&orientation=landscape"
                alt="网红爆料 - 最新网红内幕实锤解说大揭秘"
                className="w-full h-full object-cover"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-background-950/80 to-transparent p-5">
                <div className="flex items-center gap-3">
                  <div className="w-2 h-2 rounded-full bg-primary-500 animate-pulse"></div>
                  <span className="text-xs text-background-100 font-medium">实时追踪中 · 已有 128 万人在线吃瓜</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}